/**
 * Stat pills count in when they scroll into view.
 */
export default function statCounters() {
    var groups = document.querySelectorAll('.statpills, .misstats');
    if (!groups.length) { return; }

    function countUp(el, delay) {
        if (el.dataset.fxRun) { return; }

        var final = el.textContent.trim();
        var match = final.match(/^([\d,]+)(\+?)$/);
        if (!match) { return; }

        el.dataset.fxRun = '1';

        var target = parseInt(match[1].replace(/,/g, ''), 10);
        var suffix = match[2] || '';
        var duration = 2300;
        var done = false;

        // Pills are content-sized, so hold the width while the digits change.
        var pill = el.closest('.bt');
        var lock = pill && pill.getBoundingClientRect().width;
        if (lock) { pill.style.minWidth = Math.ceil(lock) + 'px'; }

        function finish() {
            if (done) { return; }
            done = true;
            el.textContent = final;
            if (lock) { pill.style.minWidth = ''; }
        }

        el.textContent = '0';

        setTimeout(function () {
            var start = performance.now();
            (function step() {
                if (done) { return; }
                var k = Math.min((performance.now() - start) / duration, 1);
                var eased = 1 - Math.pow(1 - k, 3);
                if (k < 1) {
                    el.textContent = Math.round(target * eased).toLocaleString('en-US') + suffix;
                    requestAnimationFrame(step);
                } else {
                    finish();
                }
            })();
        }, delay || 0);

        setTimeout(finish, (delay || 0) + duration + 250);
    }

    function run(group) {
        var numbers = group.querySelectorAll('.n');
        for (var i = 0; i < numbers.length; i++) { countUp(numbers[i], i * 170); }
    }

    if (window.IntersectionObserver) {
        var io = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) { return; }
                    run(entry.target);
                    io.unobserve(entry.target);
                });
            },
            { threshold: 0.05 }
        );
        for (var i = 0; i < groups.length; i++) { io.observe(groups[i]); }
    } else {
        for (var k = 0; k < groups.length; k++) { run(groups[k]); }
    }

    // Short viewports may never clear the threshold — nothing stays at zero.
    setTimeout(function () {
        groups.forEach(function (group) {
            if (group.offsetParent) { run(group); }
        });
    }, 2600);

    // The arm switch swaps which group is visible — count the newly shown one.
    document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-arm-set]')) { return; }
        setTimeout(function () {
            groups.forEach(function (group) {
                if (group.offsetParent) { run(group); }
            });
        }, 60);
    });
}
